
import ModernTabs from '../../../common/Tabs/ModernTabs'
import Overview from './tabs/Overview';
import PatientAppointments from './tabs/PatientAppointments';
import PatientCommunicationPreference from './tabs/PatientCommunicationPreference';
import PatientInvalidData from './tabs/PatientInvalidData';
import PatientActivity from './tabs/PatientActivity';
function PatientTabs({ patient }) {

   const TabContent = [
  {
    id: 'Overview',
    label: 'Patient Info',
    icon: 'bi-person-vcard', // Represents patient profile/info
    content: <Overview patient={patient} />
  },
  {
    id: 'Appointments',
    label: 'Appointments',
    icon: 'bi-calendar-check', // Represents calendar/scheduled appointments
    content: <PatientAppointments patient={patient} />
  },
  {
    id: 'comm-pref',
    label: 'Communication Preference',
    icon: 'bi-chat-square-text', // Represents chat or communication settings
    content: <PatientCommunicationPreference patient={patient} />
  },
  {
    id: 'invalid-info',
    label: 'Invalid Info',
    icon: 'bi-exclamation-triangle', // Represents warning or invalid data
    content: <PatientInvalidData patient={patient} />
  },
  {
    id: 'activity',
    label: 'Activity',
    icon: 'bi-activity', // Represents activity or history
    content: <PatientActivity patient={patient} />
  },
];

  return (
    <>
        <ModernTabs orientation='vertical' tabs={TabContent} />
    </>
  )
}

export default PatientTabs